import React from 'react';
import { Typography } from '@mui/material';

export interface PowerUpPlanQualityDotsProps {
  filledCount: number;
}

const QUALITY_LABELS = ['Default plan', 'Starter plan', 'Good plan', 'Great plan', 'Excellent plan'];

export const PowerUpPlanQualityDots: React.FC<PowerUpPlanQualityDotsProps> = ({ filledCount }) => (
  <div className="power-up-plan-page__quality">
    <div className="power-up-plan-page__quality-dots">
      {Array.from({ length: 5 }, (_, i) => (
        <div
          key={i}
          className={`power-up-plan-page__quality-dot${i < filledCount ? ' power-up-plan-page__quality-dot--filled' : ''}`}
        />
      ))}
    </div>
    <Typography variant="caption" className="power-up-plan-page__quality-label">
      {QUALITY_LABELS[Math.min(filledCount, 5) - 1] ?? QUALITY_LABELS[0]}
    </Typography>
  </div>
);
